import { BannerProps } from "ds/components/Banner";
import { CounterProps } from "ds/components/Counter";
import { RunObservabilitySeverity } from "types/generated";

import styles from "./styles.module.css";
import { RunObservabilityFindingSeverity } from "./types";

type RunObservabilityFindingSeverityConfig = {
  label: string;
  emptyTitle: string;
  counter: CounterProps["variant"];
  banner: BannerProps["variant"];
  chip: string;
  rank: number;
};

export const RUN_OBSERVABILITY_FINDING_SEVERITIES: Record<
  RunObservabilityFindingSeverity,
  RunObservabilityFindingSeverityConfig
> = {
  [RunObservabilitySeverity.Major]: {
    label: "Major",
    emptyTitle: "No major findings for this run.",
    counter: "danger",
    banner: "danger",
    chip: styles.recommendationMajor,
    rank: 0,
  },
  [RunObservabilitySeverity.Minor]: {
    label: "Minor",
    emptyTitle: "No minor findings for this run.",
    counter: "warning",
    banner: "warning",
    chip: styles.recommendationMinor,
    rank: 1,
  },
};

const isRunObservabilityFindingSeverity = (
  severity: RunObservabilitySeverity
): severity is RunObservabilityFindingSeverity => severity in RUN_OBSERVABILITY_FINDING_SEVERITIES;

export const RUN_OBSERVABILITY_FINDING_SEVERITIES_BY_RANK = Object.values(RunObservabilitySeverity)
  .filter(isRunObservabilityFindingSeverity)
  .sort(
    (left, right) =>
      RUN_OBSERVABILITY_FINDING_SEVERITIES[left].rank -
      RUN_OBSERVABILITY_FINDING_SEVERITIES[right].rank
  );
